import React, { Fragment } from "react";
//import FooterCSS from "./Footer.module.css";
import FooterCSS from "./Footer.module.scss";
import addlogo from "../../assets/images/footer/ADDVantage_Logo.svg";
import { emailIcon, phoneIcon, pinIcon } from "./FooterIconSVG";
const Footer = () => {
  return (
    <Fragment>
      <div className={FooterCSS.footer_wrapper}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-3">
                  <h3 className="font-12 weight-400 text-blue line-height-22 margin-bottom-5">
                    Powered by
                  </h3>
                  <img alt="alldaydr logo" src={addlogo} width="150"></img>
                </div>
                <div className={`col-md-3 ${FooterCSS.footer_middle}`}>
                  {pinIcon()}
                  <h4 className="font-12 weight-600 text-heading line-height-22 margin-bottom-2">
                    Address:
                  </h4>
                  <p className="text-blackk font-12 weight-400 line-height-22 margin-bottom-0">
                    Clive House, Clive Street, <br></br>Bolton BL1 1ET
                  </p>
                </div>
                <div className={`col-md-2 ${FooterCSS.footer_middle}`}>
                  {phoneIcon()}
                  <h4 className="font-12 weight-600 text-heading line-height-22 margin-bottom-2">
                    Phone:
                  </h4>
                  <a
                    className="text-blackk font-12 weight-400 line-height-22 link_hover"
                    href="tel:02080166020"
                    title="Phone Number"
                  >
                    02080166020
                  </a>
                </div>
                <div className={`col-md-4 ${FooterCSS.footer_middle}`}>
                  {emailIcon()}
                  <h4 className="font-12 weight-600 text-heading line-height-22 margin-bottom-2">
                    Email:
                  </h4>
                  <a
                    className="text-blackk font-12 weight-400 line-height-22 link_hover"
                    href="mailto:info@addvantage-technologies.co.uk"
                    title="Email Address"
                  >
                    info@addvantage-technologies.co.uk
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center w-100 justify-content-center mt-2">
                <p className="margin-0 font-12 weight-500 text-white">
                  <a
                    rel="noreferrer"
                    className="text-blackk font-12 weight-400 line-height-22 link_hover"
                    href="https://www.alldaydr.com/terms_condition"
                    target={"_blank"}
                    title="Terms and Conditions"
                  >
                    Terms &amp; Conditions
                  </a>
                </p>
                &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
                <p className="margin-0 font-12 weight-500">
                  <a
                    rel="noreferrer"
                    className="text-blackk font-12 weight-400 line-height-22 link_hover"
                    href="https://www.alldaydr.com/privacy_policy"
                    target={"_blank"}
                    title="Privacy Policy"
                  >
                    Privacy Policy
                  </a>
                </p>
                &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
                <p className="margin-0 font-12 weight-500">
                  Version: {JSON.parse(localStorage.getItem("APP_VERSION"))}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
